import {
	ID_FATHER_NODE,
	LIMIT_LENGTH_TITLE_FATHER_NODE,
	POSITION_TO_START_GET_FATHER_NODE,
	SHORTENING,
} from "./constants"

export const generateTitleFatherNode = (titleFatherNode = "") => {
	return titleFatherNode.trim().length > LIMIT_LENGTH_TITLE_FATHER_NODE
		? `${titleFatherNode.substring(
				POSITION_TO_START_GET_FATHER_NODE,
				LIMIT_LENGTH_TITLE_FATHER_NODE
		  )}${SHORTENING}`
		: titleFatherNode
}

export const validateIsFatherNode = (idFatherNode = "") => {
	return idFatherNode === ID_FATHER_NODE
}
